<template>
  <div class="invoice-create-top-grid">
    <InvoiceCreateReceiverCard
      :customer-options="customerOptions"
      :selected-receiver="selectedReceiver"
      :tax-regime-options="taxRegimeOptions"
      :cfdi-use-options="cfdiUseOptions"
      :payment-method-options="paymentMethodOptions"
      :payment-form-options="paymentFormOptions"
      :read-only="readOnly"
      :receiver-locked="receiverLocked"
      :inline-billing-data-only="inlineBillingDataOnly"
      :inline-customer-id="inlineCustomerId"
      @select-receiver="$emit('select-receiver', $event)"
      @create-inline-customer="$emit('create-inline-customer', $event)"
    />

    <InvoiceCreateInfoCard
      :issuer="issuer"
      :invoice-info="invoiceInfo"
      :selected-receiver="selectedReceiver"
      :serial-options="serialOptions"
      :payment-method-options="paymentMethodOptions"
      :payment-form-options="paymentFormOptions"
      :global-invoice-periodicity-options="globalInvoicePeriodicityOptions"
      :read-only="readOnly"
      @invoice-info-change="$emit('invoice-info-change', $event)"
    />
  </div>
</template>

<script>
import InvoiceCreateReceiverCard from '@/components/invoices/create/InvoiceCreateReceiverCard.vue';
import InvoiceCreateInfoCard from '@/components/invoices/create/InvoiceCreateInfoCard.vue';

export default {
  name: 'InvoiceCreateTopSection',
  components: {
    InvoiceCreateReceiverCard,
    InvoiceCreateInfoCard,
  },
  props: {
    issuer: {
      type: Object,
      required: true,
    },
    customerOptions: {
      type: Array,
      default: () => [],
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    taxRegimeOptions: {
      type: Array,
      default: () => [],
    },
    cfdiUseOptions: {
      type: Array,
      default: () => [],
    },
    serialOptions: {
      type: Array,
      default: () => [],
    },
    paymentMethodOptions: {
      type: Array,
      default: () => [],
    },
    paymentFormOptions: {
      type: Array,
      default: () => [],
    },
    globalInvoicePeriodicityOptions: {
      type: Array,
      default: () => [],
    },
    invoiceInfo: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    receiverLocked: {
      type: Boolean,
      default: false,
    },
    inlineBillingDataOnly: {
      type: Boolean,
      default: false,
    },
    inlineCustomerId: {
      type: Number,
      default: 0,
    },
  },
  emits: [
    'select-receiver',
    'create-inline-customer',
    'invoice-info-change',
  ],
};
</script>
